import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

export default function WalletIndexNav({
    state,
    setstate,
    title
}) {
    return (
        <section className="mt-4 px-4">
            <div
                className="flex items-center justify-between p-[10px] !py-[15px] shadow-blue_dropshadow rounded-[8px] bg-accent"
                onClick={() => {
                    setstate(!state);
                }}
            >
                <h1 className="text-white headingText capitalize">
                    {title}
                </h1>
                <IoIosArrowForward className="text-2xl text-white" />
            </div>
        </section>
    )
}